import { defineComponent, openBlock, createElementBlock, createVNode, unref, renderSlot } from "vue";
import { IconErrorStroke } from "@rei/cedar";
const _hoisted_1 = {
  class: "error-text"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "GenericErrorText",
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [createVNode(unref(IconErrorStroke), {
        "inherit-color": "",
        class: "error-text__icon"
      }), renderSlot(_ctx.$slots, "default", {}, void 0, true)]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=GenericErrorText2.mjs.map
